import { defaultClient } from '@api/client';

export const createUser = (payload) => {
  return defaultClient.post('/admin/users', payload);
};
